import { Icon, Switch, Box, Flex } from '@chakra-ui/react';
import './KSwitch.css';
import { KFormLabel } from '@/ui-library/components/atoms/KFormLabel';

interface SwitchProps {
  customStyles?: React.CSSProperties;
  [key: string]: any;
  isDisabled?: boolean;
  onChange?: (isChecked: boolean) => void;
  colorScheme?: string;
  switchIcon?: any;
  backgroundColor?: string;
  label?: string;
  switchIconProps?: any;
}

export const KSwitch: React.FC<SwitchProps> = ({
  variant = 'default',
  customStyles = {},
  isChecked = false,
  isDisabled = false,
  iconEnabled = false,
  onChange = () => {},
  label,
  backgroundColor = 'primary-500',
  colorScheme = 'secondary',
  switchIcon,
  switchIconProps,
  ...restProps
}) => {
  // Handler to call the parent's onChange with the new value
  const handleChange = () => {
    onChange(!isChecked); // Pass the new toggled value to parent
  };

  return (
    <Flex alignItems="center" justifyContent="space-between">
      <Flex flexDir="column">
        {label && (
          <KFormLabel
            style={{
              ...customStyles,
            }}
            variant="subLabel"
          >
            {label}
          </KFormLabel>
        )}
      </Flex>
      <Box position="relative" display="inline-block">
        <Switch
          isChecked={isChecked}
          isDisabled={isDisabled}
          onChange={handleChange}
          colorScheme={colorScheme}
          sx={{
            '.chakra-switch__track': {
              backgroundColor: isChecked && backgroundColor,
            },
            '&[data-checked] .chakra-switch__track': {
              backgroundColor: backgroundColor,
            },
          }}
          className="kswitch-custom"
          {...restProps}
        />
        {switchIcon && (
          <Icon
            as={switchIcon}
            w="16px"
            h="16px"
            color="base-white"
            position="absolute"
            left="6px"
            top="50%"
            transform="translateY(-50%)"
            zIndex={999}
            pointerEvents="none"
            {...switchIconProps}
          />
        )}
      </Box>
    </Flex>
  );
};
